import { render, staticRenderFns } from "./feedback_length.vue?vue&type=template&id=0387ebad&"
import script from "./feedback_length.vue?vue&type=script&lang=js&"
export * from "./feedback_length.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports